export default __webpack_public_path__ + "static/media/P4.26c00fef.png";